import {Typography} from "antd";
import React from "react";

export default ({title, sub}) => <div style={{paddingBottom: "1rem", textAlign: 'center'}}>
  <Typography.Title level={2}>{title}</Typography.Title>
  {sub && <div className="ant-card-meta-description">
    {sub}
  </div>}
</div>

